import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19c8662b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "dropZoneRef",
  class: "drive"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Drop some files here ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_load_bar = _resolveComponent("drive-load-bar")!
  const _component_app_drop_zone = _resolveComponent("app-drop-zone")!
  const _component_drive_items = _resolveComponent("drive-items")!
  const _component_drive_photos = _resolveComponent("drive-photos")!
  const _component_drive_mixed = _resolveComponent("drive-mixed")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.mainStore.uploadInfos.length && !_ctx.mainStore.isMobile)
      ? (_openBlock(), _createBlock(_component_drive_load_bar, {
          key: 0,
          uploadInfo: _ctx.mainStore.getUploadInfo,
          class: "loadbar"
        }, null, 8, ["uploadInfo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isOverDropZone)
        ? (_openBlock(), _createBlock(_component_app_drop_zone, {
            key: 0,
            "indents-height": 80,
            class: "drop-zone-box"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.mainStore.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "scroll",
            ref: "scroller",
            onScroll: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            _createVNode(_component_refresh_pull, {
              modelValue: _ctx.loadingPull,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loadingPull) = $event)),
              onRefresh: _ctx.onRefresh,
              successText: _ctx.successText,
              pullingText: _ctx.pullingText,
              loosingText: _ctx.loosingText,
              loadingText: _ctx.loadingText,
              disabled: !!_ctx.driveStore.search
            }, {
              default: _withCtx(() => [
                _createVNode(_component_drive_items, {
                  ref: "casesRef",
                  class: "mt-16",
                  title: _ctx.driveCasesTitle,
                  isNetwork: _ctx.isNetwork
                }, null, 8, ["title", "isNetwork"]),
                _createVNode(_component_drive_photos, {
                  ref: "photosRef",
                  class: "mt-16"
                }, null, 512),
                _createVNode(_component_drive_mixed, {
                  ref: "mixedRef",
                  class: "mt-16 d-mixed",
                  mixedData: _ctx.mixedData,
                  isPageLoading: _ctx.isPageLoading,
                  dataLoading: _ctx.dataLoading,
                  onRemoveFromSearch: _ctx.removeFromSearch
                }, null, 8, ["mixedData", "isPageLoading", "dataLoading", "onRemoveFromSearch"]),
                _withDirectives(_createVNode(_component_app_no_message, {
                  icon: _ctx.noDataMessage.icon
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.noDataMessage.text), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]), [
                  [_vShow, _ctx.noDataMessage && !_ctx.dataLoading]
                ])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText", "disabled"])
          ], 544))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "d-scroll",
            ref: "scroller",
            onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args)))
          }, [
            _createVNode(_component_drive_items, {
              ref: "casesRef",
              class: "mt-16",
              title: _ctx.driveCasesTitle,
              isNetwork: _ctx.isNetwork
            }, null, 8, ["title", "isNetwork"]),
            _createVNode(_component_drive_photos, {
              ref: "photosRef",
              class: "mt-16"
            }, null, 512),
            _createVNode(_component_drive_mixed, {
              ref: "mixedRef",
              class: "mt-16 d-mixed",
              mixedData: _ctx.mixedData,
              isPageLoading: _ctx.isPageLoading,
              dataLoading: _ctx.dataLoading,
              onRemoveFromSearch: _ctx.removeFromSearch
            }, null, 8, ["mixedData", "isPageLoading", "dataLoading", "onRemoveFromSearch"]),
            _withDirectives(_createVNode(_component_app_no_message, {
              icon: _ctx.noDataMessage.icon
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.noDataMessage.text), 1)
              ]),
              _: 1
            }, 8, ["icon"]), [
              [_vShow, _ctx.noDataMessage && !_ctx.dataLoading]
            ])
          ], 544))
    ], 512)
  ], 64))
}